import { Button, Flex, Grid, H4 } from '@decisiv/ui-components';
import { t, Trans } from '@lingui/macro';
import iconix from '@decisiv/iconix';
import { JsonEditor } from 'json-edit-react';

import Copy from '@decisiv/iconix/lib/components/Copy';
import React from 'react';
import { PropTypes } from 'prop-types';
import { CODE_EDITOR_THEME } from '../../theme/jsonEditorTheme';
import { DeveloperCodeViewManualInvocation } from '../../pages/IntegrationDetailPage/style';
import WrapperWithLoading from '../WrapperWithLoading';
import TriggerTypesMenu from './TriggerTypesMenu';
import formatJsonText from '../../utils/formatJsonText';

export default function InvocationPayload({
  loading,
  resetPayload,
  integration,
  selectedTriggerType,
  onSelectTriggerType,
  disableTriggerType,
  invocationInput,
  setInvocationInput,
}) {
  return (
    <Grid.Column span="8">
      <H4>
        <Flex flexDirection="row">
          <Grid.Column
            span="10"
            style={{
              paddingTop: '15px',
            }}
          >
            <Trans>Input Invocation Payload</Trans>
          </Grid.Column>
          <Grid.Column span="2" style={{ paddingTop: '15px' }}>
            <Button
              text={t`Reset Payload`}
              size="small"
              variant="ghost"
              icon={iconix.Undo}
              onClick={resetPayload}
              style={{
                marginRight: '0px',
                marginLeft: 'auto',
              }}
            />
          </Grid.Column>
        </Flex>
      </H4>
      <Flex flexDirection="row">
        <Grid.Column span="12">
          <TriggerTypesMenu
            integration={integration}
            selectedTriggerType={selectedTriggerType}
            onSelectTriggerType={onSelectTriggerType}
            disableTriggerType={disableTriggerType}
          />
        </Grid.Column>
      </Flex>
      <Flex style={{ paddingBottom: '10px' }}>
        <WrapperWithLoading loading={loading}>
          <Grid.Column span="12">
            <DeveloperCodeViewManualInvocation id="codeBox">
              {invocationInput && (
                <JsonEditor
                  rootName=""
                  showCollectionCount={false}
                  theme={CODE_EDITOR_THEME}
                  data={JSON.parse(invocationInput)}
                  setData={(e) => setInvocationInput(JSON.stringify(e))}
                />
              )}
            </DeveloperCodeViewManualInvocation>
            <Button
              style={{
                borderRadius: '4px',
                marginRight: '0px',
                marginLeft: 'auto',
                marginTop: '-15px',
              }}
              icon={Copy}
              text={t`Copy`}
              id="copyBtn"
              variant="inverted"
              onClick={() =>
                navigator.clipboard.writeText(formatJsonText(invocationInput))
              }
              size="small"
            />
          </Grid.Column>
        </WrapperWithLoading>
      </Flex>
    </Grid.Column>
  );
}

InvocationPayload.propTypes = {
  loading: PropTypes.bool.isRequired,
  resetPayload: PropTypes.func.isRequired,
  integration: PropTypes.oneOfType([PropTypes.object]).isRequired,
  selectedTriggerType: PropTypes.string.isRequired,
  onSelectTriggerType: PropTypes.func.isRequired,
  disableTriggerType: PropTypes.bool.isRequired,
  invocationInput: PropTypes.string.isRequired,
  setInvocationInput: PropTypes.func.isRequired,
};
